import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FacebookService {

  constructor(private http: HttpClient) { }

  isFacebookPostUrlValid(url: string): Observable<any> {

    if (!url || !url.includes('facebook')) {
      return of('');
    }

    const accessToken = `${environment.facebookAppId}|${environment.facebookAppSecret}`;
    const oembedUrl = `https://graph.facebook.com/v18.0/oembed_post?url=${encodeURIComponent(url)}&access_token=${accessToken}`;

    return this.http.get<any>(oembedUrl).pipe(
      map(response => {
        return response && response.html ? { fbHtml: response.html } : {};
      }),
      catchError(error => {
        console.error('Facebook embed - oEmbed fetch error:', error);
        return of('');
      })
    );
  }

}
